import React from 'react'
import {createUseStyles} from 'react-jss'
import {Link} from 'react-router-dom'

import {bestUniversitiesPath} from '@prepler/core/lib/routesHelper'
import majors from '@prepler/core/lib/constants/majors'

import states from './states'
import Helmet from '../common/helmet'
import TitledTab from '../common/titledTab'
import BlogPosts from '../blogPosts'

const useStyles = createUseStyles((theme) => ({
	container: {
		display: 'flex',
	},
	sidebar: {
		flexShrink: '0',
		display: 'none',
		padding: '30px 0px 30px 30px',
		'@media screen and (min-width: 768px)': {
			display: 'flex',
			width: '200px',
		},
		'@media screen and (min-width: 992px)': {
			width: '290px',
		},
		'@media screen and (min-width: 1200px)': {
			width: '380px',
		},
		flexDirection: 'column',
		alignItems: 'center',
	},
	description: {
		'& p': {
			lineHeight: '1.5',
			padding: '10px 0',
		}
	},
	h2: {
		textAlign: 'left',
		fontSize: '26px',
		padding: '15px 0px 10px',
	},
	columns: {
		columnCount: '2',
		columnGap: '60px',
		'& a': {
			lineHeight: '20px',
			marginBottom: '15px',
		}
	},
}));

const Rankings = () => {
	const classes = useStyles();

	return (
		<>
			<Helmet
				title={`${(new Date()).getFullYear()} College Ranking`}
				description={`Prepler released in-depth ${(new Date()).getFullYear()} College Ranking. Explore the best colleges based on major, state and key statistics from the U.S. Department of Education and students reviews.`}
			/>
			<div className={classes.container}>
				<TitledTab title={`${(new Date()).getFullYear()} College Ranking`}>
					<div className={classes.description}>
						<h2 className={classes.h2}>Best Colleges</h2>
						<p>
							Discover the {(new Date()).getFullYear()} Best Colleges in America to find your best college matches.
						</p>
						<div className={classes.columns}>
							<Link to={bestUniversitiesPath()}>Best Colleges in America</Link>
							<Link to={bestUniversitiesPath({bestSection: 'liberal-arts-colleges'})}>Best Liberal Arts Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'private-colleges'})}>Best Private Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'for-profit-colleges'})}>Best For-Profit Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'public-4-year-colleges'})}>Best Public Four Year Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'public-colleges'})}>Best Public Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: '4-year-colleges'})}>Best Four Year Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'community-colleges'})}>Top Community Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'junior-colleges'})}>Top Junior Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'religious-colleges'})}>Top Religious Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'catholic-colleges'})}>Best Catholic Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'online-colleges'})}>Best Online Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'womens-colleges'})}>Best Women's Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'small-colleges'})}>Best Small Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'big-colleges'})}>Best Big Colleges</Link>
							<Link to={bestUniversitiesPath({bestSection: 'colleges-with-no-application-fee'})}>Best Colleges with No Application Fee</Link>
							<Link to={bestUniversitiesPath({bestSection: 'hbcu-colleges'})}>Best HBCU Schools</Link>
						</div>

						<h2 className={classes.h2}>Best Colleges by State</h2>
						<p>
							Explore the {(new Date()).getFullYear()} top-ranked colleges in each state across the U.S. to find a good one near you.
						</p>
						<div className={classes.columns}>
							{states.map(({name, param}) => (
								<Link to={bestUniversitiesPath({state: param})}>Best Colleges in {name}</Link>
							))}
						</div>

						<h2 className={classes.h2}>Best Colleges by Major</h2>
						<p>
							Explore the {(new Date()).getFullYear()} College Rankings by Major to see which college is a good academic fit for you.
						</p>
						<div className={classes.columns}>
							{majors.map((majorName) => (
								<Link key={majorName} to={bestUniversitiesPath({bestSection: 'major', rating_major_query: majorName})}>
									Best {majorName} Colleges
								</Link>
							))}
						</div>
					</div>
				</TitledTab>
				<div className={classes.sidebar}>
					<BlogPosts slug="gpa-calculator-page"/>
				</div>
			</div>
		</>
	);
}

export default Rankings;
